<nb-card [accent]="status">
    <nb-card-header class="{{status}}">
        <div class="close-button" *ngIf="!show_cancel_button">
            <button nbButton ghost (click)="dismiss()">
                <nb-icon icon="close-outline" class="close-icon"></nb-icon>
            </button>
        </div>
        <nb-icon icon="{{setIcon(status)}}"></nb-icon>
        <h6>
            {{ header }}
        </h6>
    </nb-card-header>
    <nb-card-body>
        <div>
            <p [innerHTML]="body"></p>
            <form>
                <nb-form-field>
                    <nb-icon nbPrefix icon="at-outline" pack="eva"></nb-icon>
                    <input type="text" nbInput>
                  </nb-form-field>

                  <button nbButton status="primary">Simpan</button>
            </form>
        </div>
    </nb-card-body>
    <nb-card-footer>
        <button class="float-right" nbButton status="basic" (click)="dismiss()" ghost status="basic"
            *ngIf="show_cancel_button">{{ btn_cancel_name
            }}</button>
        <button class="float-right" nbButton status="basic" (click)="confirm()" ghost status="primary" *ngIf="show_confirm_btn">{{
            btn_confirm_name }}</button>
    </nb-card-footer>
</nb-card>